export function asDisplayText(payload, fallback = '') {
  if (typeof payload === 'string') return payload
  if (payload && typeof payload === 'object' && typeof payload.text === 'string') return payload.text
  return fallback
}

export function ensureTextPayload(payload, fallbackText = '') {
  const text = asDisplayText(payload, fallbackText)
  const reason = payload && typeof payload === 'object' && typeof payload.reason === 'string'
    ? payload.reason
    : undefined
  return { text, ...(reason ? { reason } : {}) }
}

